import { GET_MANCHESTER_READER_DATA_SUCCESS, GET_MANCHESTER_READER_DATA_FAILURE } from '../constants/MTag';
import { onSuccess, onFailure } from './common';

const initStat = { data: [], error: false, errorData: '', isLoading: true };

export default (state = initStat, action) => {
	switch (action.type) {
		case GET_MANCHESTER_READER_DATA_SUCCESS:
			return onSuccess(state, action);
		case GET_MANCHESTER_READER_DATA_FAILURE:
			return onFailure(state, action);
		default:
			return { ...state };
	}
};
